import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const loadMinimumOrdersByProductGroup = (
  data: any
): Promise<{ data: any; total: number }> => {
  return axios.get('/parameters/min-order-per-product-group', data)
}

export function useLoadMinimumOrdersByProductGroup(query: any) {
  return useQuery(
    ['minimumOrdersByProductGroup', query],
    () => loadMinimumOrdersByProductGroup(query),
    {
      onError: () =>
        toast.error(
          'Não foi possível carregar os tipos de pedido mínimo por grupo de produto!',
          {
            toastId: 'loadMinimumOrdersByProductGroup'
          }
        )
    }
  )
}
